import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'
Vue.use(Router)

// 解决两次访问相同路由地址报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}
export default new Router({
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: Layout,
      redirect: 'index',
      children: [
        {
          path: 'index',
          component: resolve =>  require(['../view/index.vue'], resolve),
          name: 'index',
          meta: {title: '首页'}
        },{ 
          path: 'product',
          component: resolve =>  require(['../view/product/index.vue'], resolve),
          name: 'product',
          meta: {title: '评估量表'}
        },{
          path: 'product/detail',
          component: resolve =>  require(['../view/product/detail.vue'], resolve),
          name: 'productDetail',
          meta: {title: '评估量表'}
        },{
          path: 'train',
          component: resolve =>  require(['../view/train/index.vue'], resolve),
          name: 'train',
          meta: {title: '培训信息'}
        },{
          path: 'consult',
          component: resolve =>  require(['../view/consult/index.vue'], resolve),
          name: 'consult',
          meta: {title: '咨询中心'}
        },{
          path: 'news',
          component: resolve =>  require(['../view/news/index.vue'], resolve),
          name: 'news',
          meta: {title: '新闻资讯'}
        },{
          path: 'news/detail',
          component: resolve =>  require(['../view/news/detail.vue'], resolve),
          name: 'newsDetail',
          meta: {title: '详情'}
        },{
          path: 'about',
          component: resolve =>  require(['../view/about/index.vue'], resolve),
          name: 'about',
          meta: {title: '公司简介'}
        },{
          path: 'about/team',
          component: resolve =>  require(['../view/about/team.vue'], resolve),
          name: 'aboutTeam',
          meta: {title: '研发智库'}
        },{
          path: 'about/know',
          component: resolve =>  require(['../view/about/know.vue'], resolve),
          name: 'aboutKnow',
          meta: {title: '版权声明'}
        },{
          path: 'about/terms',
          component: resolve =>  require(['../view/about/terms.vue'], resolve),
          name: 'aboutTerms',
          meta: {title: '使用条款'}
        },{
          path: 'about/other',
          component: resolve =>  require(['../view/about/other.vue'], resolve),
          name: 'aboutOther',
          meta: {title: '其他信息'}
        },
        {
          path: 'jifen',
          beforeEnter() {
            window.open('https://www.hsyl-tech.com/scaleClient/', '_blank');
          },
        },
      ]
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js